// Router state that tells a page the user came from My Hub, so its breadcrumb
// can lead back there instead of to the Platforms list.
export const FROM_MYHUB = { from: "myhub" } as const;

export function isFromMyHub(state: unknown): boolean {
  return (
    typeof state === "object" &&
    state !== null &&
    (state as { from?: unknown }).from === FROM_MYHUB.from
  );
}
